import React from 'react';
import Card from '../common/Card/Card';
import ChevronLink from '../common/ChevronLink/ChevronLink';
import { useLocation } from 'react-router-dom';
import { useCouncilPath } from '../../hooks/useCouncilPath';
import './AnalysesNavItem.css';

type Props = {
    icon: React.ReactNode;
    title: string;
    path: string;
    compact?: boolean;
};

const AnalysisNavItem = ({ icon, title, path, compact }: Props) => {
    const councilPath = useCouncilPath();

    const location = useLocation();
    const fullPath = councilPath('analyzy', path);
    const isSelected = location.pathname === fullPath;

    if (compact) {
        return (
            <Card
                link={fullPath}
                className={`analyses-nav-row${isSelected ? ' active' : ''}`}
            >
                {icon}
                <span className='analyses-nav-row-label'>{title}</span>
                <ChevronLink chevronDirection='right' linkDisabled className='analyses-nav-row-chevron'/>
            </Card>
        );
    }

    return (
        <Card
            link={fullPath}
            className={`${isSelected ? 'active' : ''}`}
        >
            {icon}
            <h4>{title}</h4>
        </Card>
    );
};

export default AnalysisNavItem;
